import { LoginResponse } from '@sxm-de/dev-kits/microservices-sdk/types';

export type LoginRequest = {
    identityGrant: string;
};

export type LoginFn = (payload: LoginRequest) => Promise<LoginResponse>;

export function initLoginFn({ baseUrl }: { baseUrl: string }): LoginFn {
    return async ({ identityGrant }: LoginRequest) => {
        const url = `${baseUrl}/authenticate/login`;
        const headers = {
            Accept: 'application/json; charset=utf-8',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${identityGrant}`,
        };
        const response = await fetch(url, {
            method: 'POST',
            headers,
            credentials: 'include',
            /**
             * TODO:
             * We might need to make this body object support keepMeSignedIn prop
             */
            body: JSON.stringify({}),
        });
        const { data, error } = await response.json();
        if (error) {
            throw error;
        }
        return data;
    };
}
